import React from 'react';
import PricingCard from '../../components/common/PricingCard';
import Accordion from '../../components/common/Accordion';

const Pricing = () => {
  // Pricing plans
  const plans = [
    {
      id: 1,
      name: 'Ücretsiz',
      price: '0',
      period: 'ay',
      features: [
        '5 belge/ay',
        'Temel şablonlar',
        'Email destek',
        'PDF/Word indirme',
        'Temel validasyon',
      ],
      isPopular: false,
      buttonText: 'Ücretsiz Başla',
    },
    {
      id: 2,
      name: 'Pro',
      price: '299',
      period: 'ay',
      features: [
        'Sınırsız belge',
        'Tüm şablonlar',
        'Öncelikli destek',
        'E-imza entegrasyonu',
        'Gelişmiş validasyon',
        'API erişimi',
        'Özel logo ve branding',
      ],
      isPopular: true,
      buttonText: 'Pro Başla',
    },
    {
      id: 3,
      name: 'Kurumsal',
      price: '',
      period: '',
      features: [
        'Özel şablonlar',
        'Sınırsız kullanıcı',
        'API erişimi',
        'Özel destek',
        'SLA garantisi',
        'Eğitim ve onboarding',
        'White-label çözüm',
        'Özel entegrasyonlar',
      ],
      isPopular: false,
      buttonText: 'Teklif Al',
    },
  ];

  // Pricing FAQs
  const pricingFAQs = [
    {
      id: 1,
      question: 'Ücretsiz deneme süresi var mı?',
      answer:
        'Evet! 14 gün boyunca tüm özelliklere ücretsiz erişebilirsiniz. Kredi kartı bilgisi gerektirmez.',
    },
    {
      id: 2,
      question: 'İstediğim zaman planımı değiştirebilir miyim?',
      answer:
        'Evet, istediğiniz zaman planınızı yükseltebilir veya düşürebilirsiniz. Değişiklik hemen yansır ve kalan süre oranlanır.',
    },
    {
      id: 3,
      question: 'Hangi ödeme yöntemlerini kabul ediyorsunuz?',
      answer:
        'Kredi kartı (Visa, Mastercard, Amex) ve banka havalesi ile ödeme yapabilirsiniz. Kurumsal planlar için fatura düzenleyebiliriz.',
    },
    {
      id: 4,
      question: 'Kurumsal plan için nasıl teklif alabilirim?',
      answer:
        'İletişim sayfamızdan veya destek@contractcode.com.tr adresinden bize ulaşabilirsiniz. Detaylı ihtiyaçlarınızı dinleyerek size özel bir teklif hazırlayacağız.',
    },
  ];

  const handlePlanSelect = (planName) => {
    console.log(`Plan selected: ${planName}`);
  };

  return (
    <div>
      {/* Hero Section */}
      <section className="bg-gray-50 py-16 md:py-24">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Fiyatlandırma
          </h1>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto mb-8">
            İhtiyacınıza uygun planı seçin ve hemen başlayın. Ücretsiz deneme
            süresiyle risk almadan test edin.
          </p>
          <div className="inline-flex items-center gap-2 px-6 py-3 bg-primary-50 border border-primary-200 rounded-lg">
            <svg
              className="w-5 h-5 text-primary-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <span className="text-primary-700 font-semibold">
              14 gün ücretsiz deneme - Kredi kartı gerekmez
            </span>
          </div>
        </div>
      </section>

      {/* Pricing Cards Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {plans.map((plan) => (
                <PricingCard
                  key={plan.id}
                  name={plan.name}
                  price={plan.price}
                  period={plan.period}
                  features={plan.features}
                  isPopular={plan.isPopular}
                  buttonText={plan.buttonText}
                  onSelect={() => handlePlanSelect(plan.name)}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Features Comparison Table */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 text-center">
              Özellik Karşılaştırması
            </h2>
            <p className="text-lg text-gray-600 mb-12 text-center">
              Hangi planın sizin için en uygun olduğunu görün
            </p>

            <div className="bg-white rounded-lg shadow-sm overflow-hidden">
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-gray-50 border-b border-gray-200">
                    <tr>
                      <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">
                        Özellikler
                      </th>
                      <th className="px-6 py-4 text-center text-sm font-semibold text-gray-900">
                        Ücretsiz
                      </th>
                      <th className="px-6 py-4 text-center text-sm font-semibold text-gray-900 bg-primary-50">
                        Pro
                      </th>
                      <th className="px-6 py-4 text-center text-sm font-semibold text-gray-900">
                        Kurumsal
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    <tr>
                      <td className="px-6 py-4 text-sm text-gray-900">
                        Belge sayısı
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-600 text-center">
                        5/ay
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-900 text-center bg-primary-50 font-semibold">
                        Sınırsız
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-900 text-center font-semibold">
                        Sınırsız
                      </td>
                    </tr>
                    <tr>
                      <td className="px-6 py-4 text-sm text-gray-900">
                        Şablon erişimi
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-600 text-center">
                        Temel
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-900 text-center bg-primary-50 font-semibold">
                        Tümü
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-900 text-center font-semibold">
                        Tümü + Özel
                      </td>
                    </tr>
                    <tr>
                      <td className="px-6 py-4 text-sm text-gray-900">E-imza</td>
                      <td className="px-6 py-4 text-center">
                        <span className="text-gray-400">✗</span>
                      </td>
                      <td className="px-6 py-4 text-center bg-primary-50">
                        <span className="text-primary-600">✓</span>
                      </td>
                      <td className="px-6 py-4 text-center">
                        <span className="text-primary-600">✓</span>
                      </td>
                    </tr>
                    <tr>
                      <td className="px-6 py-4 text-sm text-gray-900">
                        API erişimi
                      </td>
                      <td className="px-6 py-4 text-center">
                        <span className="text-gray-400">✗</span>
                      </td>
                      <td className="px-6 py-4 text-center bg-primary-50">
                        <span className="text-primary-600">✓</span>
                      </td>
                      <td className="px-6 py-4 text-center">
                        <span className="text-primary-600">✓</span>
                      </td>
                    </tr>
                    <tr>
                      <td className="px-6 py-4 text-sm text-gray-900">Destek</td>
                      <td className="px-6 py-4 text-sm text-gray-600 text-center">
                        Email
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-900 text-center bg-primary-50 font-semibold">
                        Öncelikli
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-900 text-center font-semibold">
                        7/24 Özel
                      </td>
                    </tr>
                    <tr>
                      <td className="px-6 py-4 text-sm text-gray-900">
                        SLA garantisi
                      </td>
                      <td className="px-6 py-4 text-center">
                        <span className="text-gray-400">✗</span>
                      </td>
                      <td className="px-6 py-4 text-center bg-primary-50">
                        <span className="text-gray-400">✗</span>
                      </td>
                      <td className="px-6 py-4 text-center">
                        <span className="text-primary-600">✓</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing FAQ Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 text-center">
              Fiyatlandırma Hakkında SSS
            </h2>
            <p className="text-lg text-gray-600 mb-12 text-center">
              Fiyatlandırma ile ilgili sık sorulan sorular
            </p>

            <Accordion items={pricingFAQs} />
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-primary-600">
        <div className="container mx-auto px-4 text-center">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Hemen Başlayın
            </h2>
            <p className="text-lg text-primary-100 mb-8">
              14 gün ücretsiz deneme süresiyle tüm özellikleri test edin. Kredi
              kartı bilgisi gerektirmez.
            </p>
            <button
              onClick={() => handlePlanSelect('Pro')}
              className="inline-block px-8 py-4 bg-white text-primary-600 font-semibold rounded-lg hover:bg-gray-100 transition-colors text-lg"
            >
              Ücretsiz Deneyin
            </button>
            <p className="text-primary-100 text-sm mt-4">
              Dilediğiniz zaman iptal edebilirsiniz
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

Pricing.propTypes = {};

export default Pricing;

